module.exports = __webpack_public_path__ + "img/ico-sale.385f65a2.svg";